import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import Router from "../routes/routes";
import { persistor, store } from "../store";
import { mixpanelInitialize } from '../utils/mixpanel';

import "../i18n";
import "../style.css";
import "../styles/global/default.scss";

const App = () =>  {
	useEffect(() => {
		mixpanelInitialize();
	}, []);
	return (
		<Provider store={store}>
			<PersistGate loading={null} persistor={persistor}>
				<div id="recaptcha-container" style={{ display: "none" }}></div>
				<div className="App">
					<Router />
				</div>
			</PersistGate>
		</Provider>
	);
};

export default App;
